/*
 * Public API Surface of ngx-resizable
 */

export * from './lib/ngx-resizable.service';
export * from './lib/resizable/resizable.component';
export * from './lib/ngx-resizable.module';
